import { render } from "./InterfaceTabHeader.vue?vue&type=template&id=08a5d978&scoped=true"
import script from "./InterfaceTabHeader.vue?vue&type=script&lang=js"
export * from "./InterfaceTabHeader.vue?vue&type=script&lang=js"

import "./InterfaceTabHeader.vue?vue&type=style&index=0&id=08a5d978&scoped=true&lang=scss"

import exportComponent from "/tmp/4f365a42-b3f2-4061-98cc-f7413900e2b1/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a5d978"]])

export default __exports__